export const formatCount = (n = 0) => {
    if (n >= 1e6) return `${(n / 1e6).toFixed(1).replace(/\.0$/, '')}M`;
    if (n >= 1e4) return `${Math.round(n / 1e3)}K`;
    return n.toLocaleString();
};
